import { TdsAccordionItem } from '@scania/tegel-react'
import type { AuditGridItemProps } from '../../types'

/**
 * This is an unfinished implementation.
 * See git history for inspiration.
 */
export function AuditGridItemCollapsible({
  header,
  children,
  className
}: AuditGridItemProps): JSX.Element {
  // const onClick = useCallback(
  //   (open: boolean) => (): void => {
  //     if (onHeaderClick && !open) onHeaderClick(id) // only trigger header click when closed
  //   },
  //   [id, onHeaderClick]
  // )

  return (
    <TdsAccordionItem header={header} className={className}>
      <div>{children}</div>
    </TdsAccordionItem>
  )
}
